import { Routine } from 'redux-saga-routines';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { ErrorCode } from '../../../../common/enums/ErrorCode';
import { errorToast, successToast } from '../../../../common/helpers/toastrHelper';
import {
  createWorkspaceApiToken,
  deactivateWorkspaceApiToken,
  deleteWorkspaceApiToken,
  getWorkspaceApiTokens,
  reactivateWorkspaceApiToken
} from '../../../../services/workspaceService';
import {
  createApiTokenRoutine,
  deactivateApiTokenRoutine,
  reactivateApiTokenRoutine,
  deleteApiTokenRoutine,
  getApiTokensRoutine
} from '../../routines';

function* getApiTokensReq() {
  try {
    const tokens = yield call(getWorkspaceApiTokens);
    yield put(getApiTokensRoutine.success(tokens));
  } catch (error) {
    yield put(getApiTokensRoutine.failure(error.message));
  }
}

function* watchGetApiTokens() {
  yield takeEvery(getApiTokensRoutine.TRIGGER, getApiTokensReq);
}

function* createApiTokenReq({ payload }: Routine<any>) {
  try {
    const data = yield call(createWorkspaceApiToken, payload);
    yield put(createApiTokenRoutine.success(data));
    yield call(successToast, 'New API token was successfully created', 'tokenCreated');
  } catch (error) {
    if (error.errorCode === ErrorCode.InvalidData) {
      yield call(errorToast, 'API token name already in use', 'tokenNameError');
    }
    yield put(createApiTokenRoutine.failure(error.message));
  }
}

function* watchCreateApiToken() {
  yield takeEvery(createApiTokenRoutine.TRIGGER, createApiTokenReq);
}

function* deactivateApiTokenReq({ payload }: Routine<any>) {
  try {
    yield call(deactivateWorkspaceApiToken, payload);
    yield put(deactivateApiTokenRoutine.success(payload));
  } catch (error) {
    yield put(deactivateApiTokenRoutine.failure(error.message));
  }
}

function* watchDeactivateApiToken() {
  yield takeEvery(deactivateApiTokenRoutine.TRIGGER, deactivateApiTokenReq);
}

function* reactivateApiTokenReq({ payload }: Routine<any>) {
  try {
    yield call(reactivateWorkspaceApiToken, payload);
    yield put(reactivateApiTokenRoutine.success(payload));
  } catch (error) {
    yield put(reactivateApiTokenRoutine.failure(error.message));
  }
}

function* watchReactivateApiToken() {
  yield takeEvery(reactivateApiTokenRoutine.TRIGGER, reactivateApiTokenReq);
}

function* deleteApiTokenReq({ payload }: Routine<any>) {
  try {
    yield call(deleteWorkspaceApiToken, payload);
    yield put(deleteApiTokenRoutine.success(payload));
  } catch (error) {
    yield put(deleteApiTokenRoutine.failure(error.message));
  }
}

function* watchDeleteApiToken() {
  yield takeEvery(deleteApiTokenRoutine.TRIGGER, deleteApiTokenReq);
}

export default function* apiTokensSaga() {
  yield all([
    watchGetApiTokens(),
    watchCreateApiToken(),
    watchDeactivateApiToken(),
    watchReactivateApiToken(),
    watchDeleteApiToken()
  ]);
}
